import { Box, Grid } from '@mui/material';
import { useDoctorDetail } from 'app/hooks';
import { Breadcrumb, Button, DetailWrapperDiv, FileUpload, TextField } from 'app/shared';
import { t } from 'i18next';
import { useParams } from 'react-router-dom';

export const DoctorDetail = () => {
  const { id } = useParams();

  const { detail, loading, updateForm, uploadSignature, getSignature, activate, deactivate } = useDoctorDetail(
    id as string,
  );

  const { bindTextField, submit } = updateForm;

  return (
    <>
      <Breadcrumb />
      <DetailWrapperDiv>
        <Grid container spacing={4}>
          <Grid size={6}>
            <TextField label={t('doctor.lastName')} {...bindTextField({ field: 'last_name' })} />
          </Grid>
          <Grid size={6}>
            <TextField label={t('doctor.firstName')} {...bindTextField({ field: 'first_name' })} />
          </Grid>
          <Grid size={6}>
            <FileUpload label={t('doctor.attachSignature')} onFileSelect={uploadSignature} loading={loading} />
          </Grid>
          <Grid size={6}>
            <Box padding={1} gap={1} sx={{ textAlign: 'start', display: 'flex', alignItems: 'center' }}>
              <label>{detail?.has_signature ? t('doctor.hasSignature') : t('doctor.noSignature')}</label>
              {detail?.has_signature && (
                <Button variant="contained" onClick={getSignature} loading={loading}>
                  {t('actions.download')}
                </Button>
              )}
            </Box>
          </Grid>
        </Grid>
        <Box padding={4}>
          <Button sx={{ margin: 1 }} loading={loading} onClick={submit}>
            {t('actions.saveUpdate')}
          </Button>
          {detail?.is_active === true && (
            <Button sx={{ margin: 1 }} loading={loading} color="warning" onClick={deactivate}>
              {t('actions.deactivate')}
            </Button>
          )}
          {detail?.is_active === false && (
            <Button sx={{ margin: 1 }} loading={loading} color="success" onClick={activate}>
              {t('actions.activate')}
            </Button>
          )}
        </Box>
      </DetailWrapperDiv>
    </>
  );
};
